import { FCI_ERROR } from "@searchui-searchforms/shared/fci";
import type { FormMetadataResponse } from "@searchui-searchforms/shared/form-metadata";
import type { FormMetadataParams } from "@searchui-searchforms/shared/schemas";
import { serializeFormMetadataParams } from "@searchui-searchforms/shared/schemas";
import { fciFetch } from "@/shared/lib/fci";

export const getFormMetadata = (params: FormMetadataParams) => {
    const query = serializeFormMetadataParams(params);

    return fciFetch<FormMetadataResponse>(`/api/searchforms/form-metadata?${query}`, {
        fci: {
            // Fetches the entire form structure (fields, groups, layout)
            // Without it, the form cannot be rendered at all
            errorType: FCI_ERROR.Main,
            errorInfo: "getFormMetadata",
        },
    });
};
